/**
 * "Are you still there?" with the seconds left (WCAG 2.2.1: warn, and let one simple action extend).
 * The words are the backend's; a tap anywhere also counts.
 */
import { useEffect, useState } from 'react';
import { useApp } from '../../react/app';
import { useTranslate } from '../../react/hooks';
import { useStore } from '../../react/useStore';
import { Button } from '../../ui-kit/Button';
import css from './Overlays.module.css';

export function InactivityDialog() {
  const { kiosk } = useApp();
  const warning = useStore(kiosk.stores.inactivity, (w) => w);
  const t = useTranslate();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!warning) return;
    const id = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(id);
  }, [warning]);

  if (!warning) return null;
  const left = Math.max(0, Math.ceil((warning.deadline - now) / 1000));
  return (
    <div className={`${css.backdrop} ${css.centered}`} onPointerDown={() => kiosk.stillHere()}>
      <div className={css.dialog} role="alertdialog" aria-labelledby="inactivity-title">
        <h2 id="inactivity-title" className={css.title}>{t('inactivity.title')}</h2>
        <p className={css.text}>{warning.message}</p>
        <p className={css.countdown}>{t('inactivity.seconds', { n: left })}</p>
        <Button tone="primary" size="lg" icon="hand" onClick={() => kiosk.stillHere()}>{t('inactivity.here')}</Button>
      </div>
    </div>
  );
}
